// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content-policy-error {
  background: linear-gradient(135deg, rgba(220, 38, 38, 0.08) 0%, rgba(185, 28, 28, 0.05) 100%);
  border: 1.5px solid rgba(220, 38, 38, 0.25);
  border-radius: 12px;
  padding: 16px;
  animation: fadeIn 0.3s ease;
}

.content-policy-error-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
}

.content-policy-error-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background: rgba(220, 38, 38, 0.15);
  border-radius: 8px;
  color: #dc2626;
  flex-shrink: 0;
}

.content-policy-error-title {
  font-size: 15px;
  font-weight: 600;
  color: #b91c1c;
  flex: 1 1;
}

.content-policy-error-dismiss {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  background: transparent;
  border: none;
  border-radius: 6px;
  color: rgba(185, 28, 28, 0.6);
  cursor: pointer;
  transition: all 0.15s ease;
}

.content-policy-error-dismiss:hover:not(:disabled) {
  background: rgba(220, 38, 38, 0.1);
  color: #b91c1c;
}

.content-policy-error-dismiss:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.content-policy-error-message {
  font-size: 13px;
  color: rgba(127, 29, 29, 0.85);
  line-height: 1.5;
  margin: 0 0 14px 0;
}

.content-policy-error-prompt-section {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 14px;
}

.content-policy-error-label {
  font-size: 12px;
  font-weight: 500;
  color: rgba(127, 29, 29, 0.7);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.content-policy-error-textarea {
  width: 100%;
  min-height: 80px;
  padding: 10px 12px;
  background: rgba(255, 255, 255, 0.6);
  border: 1.5px solid rgba(220, 38, 38, 0.2);
  border-radius: 8px;
  font-size: 13px;
  font-family: inherit;
  color: #1f2937;
  resize: vertical;
  transition: all 0.15s ease;
  box-sizing: border-box;
}

.content-policy-error-textarea:focus {
  outline: none;
  border-color: rgba(220, 38, 38, 0.4);
  background: rgba(255, 255, 255, 0.8);
  box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.1);
}

.content-policy-error-textarea:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.content-policy-error-textarea::placeholder {
  color: rgba(127, 29, 29, 0.4);
}

.content-policy-error-hint {
  font-size: 11px;
  color: rgba(34, 197, 94, 0.9);
  font-weight: 500;
}

.content-policy-error-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.content-policy-error-retry-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);
  border: none;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  color: white;
  cursor: pointer;
  transition: all 0.15s ease;
}

.content-policy-error-retry-btn:hover:not(:disabled) {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(220, 38, 38, 0.3);
}

.content-policy-error-retry-btn:active:not(:disabled) {
  transform: translateY(0);
}

.content-policy-error-retry-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.content-policy-error-retry-btn .spinning {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Dark mode support */
@media (prefers-color-scheme: dark) {
  .content-policy-error {
    background: linear-gradient(135deg, rgba(220, 38, 38, 0.12) 0%, rgba(185, 28, 28, 0.08) 100%);
  }
  
  .content-policy-error-title {
    color: #f87171;
  }
  
  .content-policy-error-message {
    color: rgba(252, 165, 165, 0.9);
  }
  
  .content-policy-error-label {
    color: rgba(252, 165, 165, 0.7);
  }
  
  .content-policy-error-textarea {
    background: rgba(0, 0, 0, 0.3);
    border-color: rgba(220, 38, 38, 0.3);
    color: #f3f4f6;
  }
  
  .content-policy-error-textarea:focus {
    background: rgba(0, 0, 0, 0.4);
    border-color: rgba(220, 38, 38, 0.5);
  }
  
  .content-policy-error-textarea::placeholder {
    color: rgba(252, 165, 165, 0.4);
  }
  
  .content-policy-error-icon {
    background: rgba(220, 38, 38, 0.2);
    color: #f87171;
  }
  
  .content-policy-error-dismiss {
    color: rgba(252, 165, 165, 0.6);
  }
  
  .content-policy-error-dismiss:hover:not(:disabled) {
    background: rgba(220, 38, 38, 0.15);
    color: #f87171;
  }
}

`, "",{"version":3,"sources":["webpack://./src/components/editor/ContentPolicyError.css"],"names":[],"mappings":"AAAA;EACE,6FAA6F;EAC7F,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mCAAmC;EACnC,kBAAkB;EAClB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,oCAAoC;EACpC,0CAA0C;EAC1C,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,oCAAoC;EACpC,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,6FAA6F;EAC/F;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,8BAA8B;IAC9B,oCAAoC;IACpC,cAAc;EAChB;;EAEA;IACE,8BAA8B;IAC9B,oCAAoC;EACtC;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,kCAAkC;IAClC,cAAc;EAChB;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,mCAAmC;IACnC,cAAc;EAChB;AACF","sourcesContent":[".content-policy-error {\n  background: linear-gradient(135deg, rgba(220, 38, 38, 0.08) 0%, rgba(185, 28, 28, 0.05) 100%);\n  border: 1.5px solid rgba(220, 38, 38, 0.25);\n  border-radius: 12px;\n  padding: 16px;\n  animation: fadeIn 0.3s ease;\n}\n\n.content-policy-error-header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 12px;\n}\n\n.content-policy-error-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  background: rgba(220, 38, 38, 0.15);\n  border-radius: 8px;\n  color: #dc2626;\n  flex-shrink: 0;\n}\n\n.content-policy-error-title {\n  font-size: 15px;\n  font-weight: 600;\n  color: #b91c1c;\n  flex: 1;\n}\n\n.content-policy-error-dismiss {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  background: transparent;\n  border: none;\n  border-radius: 6px;\n  color: rgba(185, 28, 28, 0.6);\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.content-policy-error-dismiss:hover:not(:disabled) {\n  background: rgba(220, 38, 38, 0.1);\n  color: #b91c1c;\n}\n\n.content-policy-error-dismiss:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.content-policy-error-message {\n  font-size: 13px;\n  color: rgba(127, 29, 29, 0.85);\n  line-height: 1.5;\n  margin: 0 0 14px 0;\n}\n\n.content-policy-error-prompt-section {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin-bottom: 14px;\n}\n\n.content-policy-error-label {\n  font-size: 12px;\n  font-weight: 500;\n  color: rgba(127, 29, 29, 0.7);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.content-policy-error-textarea {\n  width: 100%;\n  min-height: 80px;\n  padding: 10px 12px;\n  background: rgba(255, 255, 255, 0.6);\n  border: 1.5px solid rgba(220, 38, 38, 0.2);\n  border-radius: 8px;\n  font-size: 13px;\n  font-family: inherit;\n  color: #1f2937;\n  resize: vertical;\n  transition: all 0.15s ease;\n  box-sizing: border-box;\n}\n\n.content-policy-error-textarea:focus {\n  outline: none;\n  border-color: rgba(220, 38, 38, 0.4);\n  background: rgba(255, 255, 255, 0.8);\n  box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.1);\n}\n\n.content-policy-error-textarea:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.content-policy-error-textarea::placeholder {\n  color: rgba(127, 29, 29, 0.4);\n}\n\n.content-policy-error-hint {\n  font-size: 11px;\n  color: rgba(34, 197, 94, 0.9);\n  font-weight: 500;\n}\n\n.content-policy-error-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n}\n\n.content-policy-error-retry-btn {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 14px;\n  background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);\n  border: none;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 500;\n  color: white;\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.content-policy-error-retry-btn:hover:not(:disabled) {\n  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);\n  transform: translateY(-1px);\n  box-shadow: 0 2px 8px rgba(220, 38, 38, 0.3);\n}\n\n.content-policy-error-retry-btn:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.content-policy-error-retry-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.content-policy-error-retry-btn .spinning {\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-4px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Dark mode support */\n@media (prefers-color-scheme: dark) {\n  .content-policy-error {\n    background: linear-gradient(135deg, rgba(220, 38, 38, 0.12) 0%, rgba(185, 28, 28, 0.08) 100%);\n  }\n  \n  .content-policy-error-title {\n    color: #f87171;\n  }\n  \n  .content-policy-error-message {\n    color: rgba(252, 165, 165, 0.9);\n  }\n  \n  .content-policy-error-label {\n    color: rgba(252, 165, 165, 0.7);\n  }\n  \n  .content-policy-error-textarea {\n    background: rgba(0, 0, 0, 0.3);\n    border-color: rgba(220, 38, 38, 0.3);\n    color: #f3f4f6;\n  }\n  \n  .content-policy-error-textarea:focus {\n    background: rgba(0, 0, 0, 0.4);\n    border-color: rgba(220, 38, 38, 0.5);\n  }\n  \n  .content-policy-error-textarea::placeholder {\n    color: rgba(252, 165, 165, 0.4);\n  }\n  \n  .content-policy-error-icon {\n    background: rgba(220, 38, 38, 0.2);\n    color: #f87171;\n  }\n  \n  .content-policy-error-dismiss {\n    color: rgba(252, 165, 165, 0.6);\n  }\n  \n  .content-policy-error-dismiss:hover:not(:disabled) {\n    background: rgba(220, 38, 38, 0.15);\n    color: #f87171;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
